import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import moment from 'moment';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  InputLabel, FormControl, FormLabel, Select, MenuItem, Accordion, AccordionSummary, TableCell,
  AccordionDetails, Typography, IconButton, TableBody, TableRow, TableHead, Table, TableContainer, Paper,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import axios from "../../../lib/axios";
import { ContactlessOutlined, Height } from '@mui/icons-material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CrudButtons from '../../../GlobalFunction/CuudButtonNew';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import { enGB } from 'date-fns/locale';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CustomAutocomplete from '../../../Components/AutoComplete/AutocompletewithoutIcon';
import { InputAdornment } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Calendar from 'react-calendar';
import EnquiryMain from '../EnquiryMaster/EnquiryMain';
import CloseIcon from '@mui/icons-material/Close';

const attributes = [
  { id: 'EnqId', label: 'Id' },
  { id: 'EnqNo', label: 'Enquiry No.' },
  { id: 'enquiryType', label: 'EnqType' },
  { id: 'FlwDt', label: 'Follow Date' },
  { id: 'FlwRmk', label: 'Flw Remark' },
  { id: 'NextFlwDt', label: 'Next Date' },
  { id: 'OtherRmk', label: 'Remark' }
];

const FollowupForm = () => {
  const [formData, setFormData] = useState({
    propertyId: '',
    propertyName: '',
    mobileNo: '',
    inquiryNo: '',
    followupId: '',
    followupDate: new Date(),
    nextFollowupDate: new Date(),
    followBy: '',
    followByName: '',
    followRemark: '',
    otherRemark: '',
    followupStatus: '',
    cancelReason: '',
    closeReason: "",
    BookId: "",
    createdBy: "",
    updatedBy: "",
    sourceName: '',
    enquiryDate: '',
    EnqId: '',
    visitWith: '',
    enquiryType: '',
    visitRemark: '',
    visitStatus: '',
    visitDate: null,
    EnqBy: '',
    Tenure: '',
    Relation: '',
    EnqFor: '',
    CheckInDt: '',
    OcupntMob: ''
  });

  const [errors, setErrors] = useState({});
  const [enquiryIds, setEnquiryIds] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [mode, setMode] = useState('add');
  const [isFormDisabled, setIsFormDisabled] = useState(false);
  const [currentFollowupId, setCurrentFollowupId] = useState(null);
  const [propertyOptions, setPropertyOptions] = useState([]);
  const [DataForPrint, setDataForPrint] = useState({});
  const [userOptions, setUserOptions] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [followupData, setFollowupData] = useState([]);
  const UserId = sessionStorage.getItem('UserId');
  const [enquiryOptions, setEnquiryOptions] = useState([]);
  const [BookNo, setBookNo] = useState([]);
  const [typedBookNo, setTypedBookNo] = useState("");
  const [isBookIdValid, setIsBookIdValid] = useState(false);
  const contentRef = useRef(null);
  const [enquiryType, setEnquiryType] = useState([])
  const [visitedwith, setVisitedwith] = useState([])
  const [enqId, setEnqId] = useState('')
  const handlePrint = useReactToPrint({ contentRef });
  const [Relation, setRelation] = useState([]);
  const [RoomType, setRoomType] = useState([]);
  const [displayCalendar, setDisplayCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [flowuser, SetFlowuser] = useState('');

  useEffect(() => {
    const getRelation = async () => {
      try {
        const response = await axios.post(`MstRelation/getMstRelationdrp`);
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setRelation(response.data.Data);
        } else {
          toast.error('Failed to fetch Relation');
        }
      } catch (error) {
        toast.error('Error fetching Relation. Please try again.');
      }
    };

    getRelation();
  }, []);

  useEffect(() => {
    const roomType = async () => {
      try {
        const response = await axios.post(
          `RoomMst/getdrpRoomTypeMst`
        );
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setRoomType(response.data.Data);
        } else {
          toast.error('Failed to fetch RoomType');
        }
      } catch (error) {
        toast.error('Error fetching RoomType. Please try again.');
      }
    };

    roomType();
  }, []);

  const columns = [
    { field: 'id', headerName: 'ID' },
    { field: 'EnqNo', headerName: 'EnqNo.' },
    { field: 'enquiryType', headerName: 'EnqType' },
    { field: 'FlwUpBy', headerName: 'LastFlwBy' },
    { field: 'followupDate', headerName: 'Date' },
    { field: 'nextFollowupDate', headerName: 'Next FlwDate' },
    { field: 'followRemark', headerName: ' Remarks' },
    { field: 'OtherRmk', headerName: 'Other Remark' },
    { field: 'flwStatus', headerName: 'Status' },
    {
      field: "followupStatus",
      headerName: "Action",
      width: 120,
      renderCell: (params) => (
        <div style={{ display: 'flex', gap: '4px' }}>
          <IconButton
            sx={{ padding: '2px' }}
            onClick={() => {
              handleEditTabledata(params.row);
            }}
            style={{ color: '#bcae01' }}
          >
            <EditIcon size="small" />
          </IconButton>
          <IconButton
            sx={{ padding: '2px' }}
            onClick={() => {
              handleDeleteTabledata(params.row);
            }}
            style={{ color: 'red' }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </div>
      )
    }
  ];

  const isFieldDisabled = (fieldName) => {
    if (formData.inquiryNo && mode === 'add') {
      if (fieldName === 'followupDate' || fieldName === 'followRemark' || fieldName === 'visitWith' || fieldName === 'visitDate') {
        return false;
      }
      return true;
    }
    return isFormDisabled;
  };

  const fetchPropertyOptions = async () => {
    try {
      const response = await axios.post(`PropertyMst/getPropertyMstdrp`, {
        UserId,
        Flag: ""
      });
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        setPropertyOptions(response.data.Data);
      } else {
        toast.error("Failed to fetch properties");
      }
    } catch (error) {
      toast.error("Error fetching properties. Please try again.");
    }
  };

  const fetchUserOptions = async (propertyIds) => {
    try {
      const response = await axios.post(
        `UserMst/getAllUserMstDashBoard`,
        {
          "SearchText": propertyIds
        }
      );
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        setUserOptions(response.data.Data);
      } else {
        toast.error("Failed to fetch users");
      }
    } catch (error) {
      toast.error("Error fetching users. Please try again.");
    }
  };

  const fetchEnquiryOptions = async () => {
    try {
      const response = await axios.post(
        `TrnEnq/GetdrpTrnEnqNo`,
        {
          Flag: ""
        }
      );
      const ids = response.data.Data.map(item => item.Id);
      setEnquiryIds(ids);
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        setEnquiryOptions(response.data.Data);
      } else {
        toast.error("Failed to fetch enquiries");
      }
    } catch (error) {
      toast.error("Error fetching enquiries. Please try again.");
    }
  };

  const fetchEnquiryType = async () => {
    try {
      const response = await axios.post(`MstEnqTp/GetMstEnqTpDrp`, {
        Flag: ""
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        setEnquiryType(response.data.Data);
      } else {
        toast.error("Failed to fetch enquiries");
      }
    } catch (error) {
      toast.error("Error fetching enquiries. Please try again.");
    }
  };

  const fetchVisitWith = async (propertyIds) => {
    try {
      const response = await axios.post(`UserMst/getAllUserMstDashBoard`, {
        "SearchText": propertyIds
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        setVisitedwith(response.data.Data);
      } else {
        toast.error("Failed to fetch enquiries");
      }
    } catch (error) {
      toast.error("Error fetching enquiries. Please try again.");
    }
  };

  const fetchBookId = async (e, Separator) => {

    let val = "";
    if (Separator === "E") {
      val = e.target.value.trim()
    } else {
      val = e.trim();
    }

    setTypedBookNo(val);

    if (val.length >= 8) {
      try {
        const response = await axios.post(
          `TrnBooking/GetTrnBookingDashBoard`,
          {
            "start": 1,
            "PageSize": 1,
            "SearchText": '',
            "Flag": '',
            "MobileNo": '',
            "BookNo": val,
            "PropId": 1,
          }
        );
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          const fetchedBookId = response.data.Data[0];
          setBookNo(fetchedBookId);
          setFormData(prev => ({
            ...prev,
            BookId: fetchedBookId.BookId,
          }));
          setIsBookIdValid(true);
        } else {
          toast.error("Invalid Booking No");
          setIsBookIdValid(false);
        }
      } catch (error) {
        toast.error('Error fetching BookId. Please try again.');
        setIsBookIdValid(false);
      }
    }
  };

  const handleEditTabledata = async (rowData) => {
    try {
      const response = await axios.post('TrnFlwup/RetriveTrnFlwup', {
        FlwId: parseInt(rowData.id),
        Flag: "E",
        CreatedBy: UserId
      });

      if (response.data.Status === 0 && response.data.Data && response.data.Data.length > 0) {
        const data = response.data.Data[0];
        const property = propertyOptions.find(p => p.Id === data.PropId);
        const followByUser = userOptions.find(u => u.Id === data.FlwUserId);
        const visitWithUser = visitedwith.find(u => u.Id === data.VisitUserId);
        const enquiryTypeObj = enquiryType.find(e => e.Id === data.EnqTypeId);

        let statusString = 'open';
        if (data.Status === '0') statusString = 'cancel';
        else if (data.Status === '5') statusString = 'close';
        console.log('statusString', statusString)
        const visitStatus = data.VisitSt === 'Y' ? 'yes' : 'no';
        const followupDate = data.FlwDt ? new Date(data.FlwDt) : new Date();
        const nextFollowupDate = data.NextFlwDt ? new Date(data.NextFlwDt) : new Date();
        const visitDate = data.VisitDt ? new Date(data.VisitDt) : null;
        const checkInDate = data.CheckInDt ? new Date(data.CheckInDt.split('T')[0]) : null;
        setFormData({
          propertyId: data.PropId?.toString() || '',
          propertyName: property?.Name || data.PropName || '',
          mobileNo: data.MobileNo || '',
          inquiryNo: data.EnqNo || '',
          EnqId: data.EnqId?.toString() || '',
          followupId: data.FlwId?.toString() || '',
          followupDate: followupDate,
          nextFollowupDate: nextFollowupDate,
          followBy: data.FlwUserId?.toString() || '',
          followByName: followByUser?.Name || '',
          followRemark: data.FlwRmk || '',
          otherRemark: data.OtherRmk || '',
          followupStatus: statusString,
          cancelReason: data.CanlRemark || '',
          createdBy: data.CreatedBy || '',
          updatedBy: data.UpdatedBy || '',
          sourceName: data.SourceName || '',
          enquiryDate: data.EnqDt || '',
          visitWith: data.VisitUserId?.toString() || '',
          enquiryType: data.EnqTypeId?.toString() || '',
          visitStatus: visitStatus,
          visitDate: visitDate,
          visitRemark: data.VisitRemark || '',
          EnqBy: data.EnqBy,
          Tenure: data.Tenure?.toString(),
          EnqFor: data.EnqFor || '',
          Relation: data.RelationId?.toString() || '',
          CheckInDt: checkInDate,
          OcupntMob: data.OcupntMob,
          RoomTypeId: data.RoomTypeId?.toString() || '',
        });

        setMode('edit');
        setIsFormDisabled(false);
        setCurrentFollowupId(data.FlwId?.toString() || '');

        if (data.EnqId) {
          await fetchFollowupList(data.EnqId.toString());
        }
      } else {
        toast.error("Can't edit this record");
      }
    } catch (error) {
      toast.error('Error fetching followup details. Please try again.');
    }
  };

  const handleDeleteTabledata = async (rowData) => {
    try {
      const response = await axios.post('TrnFlwup/RetriveTrnFlwup', {
        FlwId: parseInt(rowData.id),
        Flag: "D",
        CreatedBy: UserId
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (formData.EnqId) {
          await fetchFollowupList(formData.EnqId);
        }
      } else {
        toast.error(response.data.Message || 'Failed to delete followup');
      }
    } catch (error) {
      toast.error('Error occurred while deleting followup. Please try again.');
    }
  };

  const fetchFollowupData = async (id, flag = '') => {
    try {
      const response = await axios.post(`TrnFlwup/RetriveTrnFlwup`, {
        FlwId: parseInt(id),
        Flag: flag,
        CreatedBy: UserId
      });
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const data = response.data.Data[0];
        const enqid = response.data.Data[0].EnqId
        setEnqId(enqid)
        const property = propertyOptions.find(p => p.Id === data.PropId) || {
          Id: data.PropId,
          Name: data.PropName
        };
        const followByUser = userOptions.find(u => u.Id === data.FlwUserId);
        let statusString = 'open';
        if (data.Status === '0') statusString = 'cancel';
        else if (data.Status === '5') statusString = 'close';
        const visitStatus = data.VisitSt === 'Y' ? 'yes' : 'no';
        const retrievedEnqId = data.EnqId?.toString() || '';
        const checkInDate = data.CheckInDt ? new Date(data.CheckInDt.split('T')[0]) : null;
        setFormData({
          propertyId: data.PropId?.toString() || '',
          propertyName: property.Name || data.PropName || '',
          mobileNo: data.MobileNo || '',
          inquiryNo: data.EnqNo || '',
          EnqId: data.EnqId?.toString() || '',
          followupId: data.FlwId || data.FollowupId || '',
          // followupDate: data.FlwDt ? new Date(data.FlwDt) : new Date(),
          followupDate: new Date(),
          // nextFollowupDate: data.NextFlwDt ? new Date(data.NextFlwDt) : new Date(),
          nextFollowupDate: new Date(),
          followBy: data.FlwUserId?.toString() || '',
          followByName: followByUser?.Name || '',
          followRemark: '',
          otherRemark: '',
          followupStatus: statusString,
          cancelReason: data.CanlRemark || '',
          createdBy: data.CreatedBy || '',
          updatedBy: data.UpdatedBy || '',
          sourceName: data.SourceName || '',
          enquiryDate: data.EnqDt || '',
          visitWith: data.VisitUserId?.toString() || '',
          enquiryType: data.EnqType || '',
          visitStatus: visitStatus,
          visitDate: data.VisitDt ? new Date(data.VisitDt) : null,
          visitRemark: data.VisitRemark || '',
          EnqBy: data.EnqBy,
          RoomTypeId: data.RoomTypeId?.toString() || '',
          Tenure: data.Tenure,
          EnqFor: data.EnqFor || '',
          Relation: data.RelationId?.toString() || '',
          CheckInDt: checkInDate,
          OcupntMob: data.OcupntMob
        });
        setCurrentFollowupId(data.FlwId || data.FollowupId);
        // setCurrentFollowupId(null);
        setMode('add');
        setIsFormDisabled(false);
        await fetchFollowupList(retrievedEnqId || "40");
        await fetchUserOptions(property.Id);
        await fetchVisitWith(property.Id);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch followup data');
      }
    } catch (error) {
      toast.error('Failed to fetch followup data.');
    }
  };

  const fetchFollowupList = async (enquiryId) => {
    if (!enquiryId || enquiryId === "") {
      setFollowupData([]);
      return;
    }
    try {
      const response = await axios.post('TrnFlwup/GetTrnFlwupDashBoard', {
        start: 0,
        PageSize: 0,
        SearchText: '',
        PropId: enquiryId.toString(),
        Flag: 'ENQ',
        // FlwUserId:1
      });
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const formattedData = response.data.Data.map(item => ({
          id: item.FlwId || item.FollowupId,
          followupDate: item.FlwDt ? moment(item.FlwDt).format('DD-MM-YYYY HH:mm') : '',
          nextFollowupDate: item.NextFlwDt ? moment(item.NextFlwDt).format('DD-MM-YYYY HH:mm') : '',
          followRemark: item.FlwRmk,
          OtherRmk: item.OtherRmk,
          followupStatus: item.FollowupStatus ||
            (item.Status === '1' ? 'open' : item.Status === '2' ? 'close' : 'cancel'),
          EnqId: item.EnqId,
          EnqNo: item.EnqNo,
          FlwRmk: item.FlwRmk,
          enquiryType: item.EnqTypeNm || formData.enquiryType,
          NextFlwDt: item.NextFlwDt ? moment(item.NextFlwDt).format('DD-MM-YYYY') : '',
          FlwDt: item.FlwDt ? moment(item.FlwDt).format('DD-MM-YYYY') : '',
          FlwUpBy: item.FlwUpBy,
          flwStatus: item.flwStatus === '0' ? 'Cancel' : item.flwStatus === '1' ? 'Open' : item.flwStatus === '5' ? 'Close' : item.flwStatus || 'Unknown'
        }));
        setFollowupData(formattedData);
        setDataForPrint(formattedData);
      } else {
        setFollowupData([]);
      }
    } catch (error) {
      toast.error('No FollowUp Available');
    }
  };

  useEffect(() => {
    if (formData.EnqId) {
      fetchFollowupList(formData.EnqId);
    }
  }, [formData.EnqId]);

  // useEffect(() => {
  //   fetchPropertyOptions();
  //   fetchUserOptions();
  //   fetchEnquiryOptions();
  //   fetchEnquiryType();
  //   fetchVisitWith();

  //   const sessionData = sessionStorage.getItem('followupFormData');

  //   if (sessionData) {
  //     try {
  //       const { EnqId, FlwId, rowData, mode } = JSON.parse(sessionData);

  //       setMode(mode || 'view');
  //       if (rowData) {
  //         setCurrentFollowupId(FlwId);
  //         SetFlowuser(rowData.FlwUserId);
  //       }
  //       if (EnqId) {
  //         fetchFollowupData(EnqId);
  //       }
  //       sessionStorage.removeItem('followupFormData');
  //     } catch (error) {
  //       setMode('add');
  //     }
  //   } else {

  //     setMode('add');
  //     setIsFormDisabled(false);
  //   }
  // }, [location]);

  useEffect(() => {
    fetchPropertyOptions();
    fetchEnquiryOptions();
    fetchEnquiryType();
    fetchVisitWith();

    const sessionData = sessionStorage.getItem('followupFormData');
    const urlParams = new URLSearchParams(location.search);
    const enqIdFromUrl = urlParams.get("EnqId");

    if (sessionData) {
      try {
        const parsed = JSON.parse(sessionData);

        setMode(parsed.mode || 'view');

        if (parsed.EnqId) {
          setFormData(prev => ({ ...prev, EnqId: parsed.EnqId }));
          fetchFollowupData(parsed.EnqId);
        }

        // sessionStorage.removeItem('followupFormData');
      } catch (error) {
        console.error("Failed to parse session data", error);
      }
    }
    else if (enqIdFromUrl) {
      fetchFollowupData(enqIdFromUrl);
    }
    else if (location.state?.EnqId) {
      fetchFollowupData(location.state.EnqId);
    }
    else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  // useEffect(() => {
  //   if (currentFollowupId && propertyOptions.length > 0 && userOptions.length > 0) {
  //     fetchFollowupData(currentFollowupId);
  //   }
  // }, [propertyOptions, userOptions, currentFollowupId]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleFollowupDateChange = (date) => {
    setFormData(prev => ({
      ...prev,
      followupDate: date
    }));
  };

  const handleNextFollowupDateChange = (date) => {
    setFormData(prev => ({
      ...prev,
      nextFollowupDate: date
    }));
  };

  const handlePropertyChange = (event, newValue) => {
    if (newValue) {
      setFormData(prevState => ({
        ...prevState,
        propertyId: newValue.Id,
        propertyName: newValue.Name
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        propertyId: '',
        propertyName: ''
      }));
    }
  };

  const handleFollowByChange = (event, newValue) => {
    if (newValue) {
      setFormData(prevState => ({
        ...prevState,
        followBy: newValue.Id,
        followByName: newValue.Name
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        followBy: '',
        followByName: ''
      }));
    }
  };

  const handlePrevious = async () => {
    if (currentFollowupId && currentFollowupId > 1) {
      await fetchFollowupData(currentFollowupId, 'P');
    }
  };

  const handleNext = async () => {
    if (currentFollowupId) {
      await fetchFollowupData(currentFollowupId, 'N');
    }
  };

  const handleSave = async () => {
    const newErrors = {};

    // Only validate date difference when status is 'open'
    if (formData.followupStatus === 'open') {
      const timeDifference = Math.abs(formData.nextFollowupDate - formData.followupDate);
      const oneHourInMs = 60 * 60 * 1000;

      if (timeDifference < oneHourInMs) {
        newErrors.dateDifference = 'Next followup date must be at least 1 hour after current followup date';
      }
    }

    if (!formData.propertyId) newErrors.propertyId = 'Property is required';
    if (!formData.mobileNo) newErrors.mobileNo = 'Mobile number is required';
    if (!formData.followBy) newErrors.followBy = 'Follow by is required';
    if (!formData.followRemark) newErrors.followRemark = 'Remark is required';
    if (formData.followupStatus === 'cancel' && !formData.cancelReason) {
      newErrors.cancelReason = 'Reason is required for cancellation';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      Object.values(newErrors).forEach(errorMsg => {
        toast.error(errorMsg);
      });
      return;
    }

    try {
      const formatDateTime = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:00`;
      };
      const payload = {
        PropId: parseInt(formData.propertyId),
        EnqId: parseInt(formData.EnqId) || 0,
        // FlwId: '1',
        EnqNo: formData.inquiryNo,
        FlwDt: formatDateTime(formData.followupDate),
        NextFlwDt: formatDateTime(formData.nextFollowupDate),
        FollowBy: parseInt(formData.followBy),
        FlwRmk: formData.followRemark,
        OtherRmk: formData.otherRemark,
        FlwUserId: parseInt(formData.followBy),
        EnqTypeId: formData.enquiryType,
        LastFlwDt: formatDateTime(formData.followupDate),
        Status: formData.followupStatus === 'cancel' ? '0' :
          formData.followupStatus === 'close' ? '5' : '1',
      };
      let response;
      if (mode === 'edit' && currentFollowupId) {
        payload.FlwId = parseInt(currentFollowupId);
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axios.post('TrnFlwup/UpdateTrnFlwup', payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post('TrnFlwup/InsertTrnFlwup', payload);
      }

      if (formData.visitStatus === 'yes') {

        const visitPayload = {
          EnqId: parseInt(formData.EnqId),
          CanlRemark: formData.cancelReason || "",
          FlwUserId: parseInt(formData.followBy),
          VisitSt: formData.visitStatus === 'yes' ? 'Y' : 'N',
          VisitDt: formData.visitDate ? formData.visitDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
          VisitUserId: parseInt(formData.visitWith),
          VisitRemark: formData.visitRemark || "",
          CanlUserId: 1,
          BookId: 1,
          Status: formData.followupStatus === 'cancel' ? '0' :
            formData.followupStatus === 'close' ? '5' : '1',
          UpdatedBy: parseInt(UserId, 10),
          Flag: "Visit"
        };

        const visitResponse = await axios.post('TrnEnq/UpdateTrnEnqStatus', visitPayload);
        if (visitResponse.data.Status !== 0 || visitResponse.data.responseStatusCode !== 1) {
          toast.error('Visit details update failed: ' + (visitResponse.data.Message || 'Unknown error'));
        }
      }

      if (formData.followupStatus === 'open') {
        const openPayload = {
          EnqId: parseInt(formData.EnqId),
          CanlRemark: "",
          FlwUserId: parseInt(formData.followBy),
          VisitSt: formData.visitStatus === 'yes' ? 'Y' : 'N',
          VisitDt: formData.visitDate ? formData.visitDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
          VisitUserId: parseInt(formData.visitWith),
          VisitRemark: formData.visitRemark,
          CanlUserId: "",
          BookId: "",
          Status: formData.followupStatus === 'cancel' ? '0' :
            formData.followupStatus === 'close' ? '5' : '1',
          UpdatedBy: parseInt(UserId, 10),
          Flag: "Status"
        };
        await axios.post('TrnEnq/UpdateTrnEnqStatus', openPayload);
      }

      if (formData.followupStatus === 'close') {

        if (typedBookNo) {
          if (typedBookNo.length < 8 || !isBookIdValid) {
            toast.error("Invalid Booking No");
            setErrors(prev => ({ ...prev, BookId: true }));
            return;
          }
        }

        const closePayload = {
          EnqId: parseInt(formData.EnqId),
          CanlRemark: "",
          FlwUserId: parseInt(formData.followBy),
          VisitSt: formData.visitStatus === 'yes' ? 'Y' : 'N',
          VisitDt: formData.visitDate ? formData.visitDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
          VisitUserId: parseInt(formData.visitWith),
          VisitRemark: formData.visitRemark,
          CanlUserId: "",
          BookId: parseInt(formData.BookId, 10) || "",
          Status: formData.followupStatus === 'cancel' ? '0' :
            formData.followupStatus === 'close' ? '5' : '1',
          UpdatedBy: parseInt(UserId, 10),
          Flag: "Status"

        };

        await axios.post('TrnEnq/UpdateTrnEnqStatus', closePayload);
      }

      if (formData.followupStatus === 'cancel') {

        const cancelPayload = {
          EnqId: parseInt(formData.EnqId),
          CanlRemark: formData.cancelReason || "",
          FlwUserId: parseInt(formData.followBy),
          VisitSt: formData.visitStatus === 'yes' ? 'Y' : 'N',
          VisitDt: formData.visitDate ? formData.visitDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
          VisitUserId: parseInt(formData.visitWith),
          VisitRemark: formData.visitRemark,
          CanlUserId: parseInt(UserId, 10),
          BookId: "",
          Status: formData.followupStatus === 'cancel' ? '0' :
            formData.followupStatus === 'close' ? '5' : '1',
          UpdatedBy: parseInt(UserId, 10),
          Flag: "Status"

        };

        await axios.post('TrnEnq/UpdateTrnEnqStatus', cancelPayload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          // await fetchFollowupData(response.data.Data);
          setCurrentFollowupId(response.data.Data);
        }

        setMode('view');
        setIsFormDisabled(true);
        await fetchFollowupList(formData.EnqId || "40");
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      toast.error('Error occurred while saving. Please try again.');
    }
  };

  const handleEdit = () => {
    if (!currentFollowupId) {
      toast.error('No followup selected to edit');
      return;
    }
    setMode('edit');
    setIsFormDisabled(false);
  };

  const formatDate = (date) => {
    if (date) {
      return moment(date, 'DD/MM/YYYY').format('DD-MM-YYYY');
    }
    return '';
  };

  const handleDate = (date) => {
    setSelectedDate(date);
    setFormData((prevState) => ({ ...prevState, CheckInDt: formatDate(date) }));
    setDisplayCalendar(false);
  };

  const handleAdd = () => {
    navigate('/enquiry')
    // setFormData({
    //   propertyId: '',
    //   propertyName: '',
    //   mobileNo: '',
    //   inquiryNo: '',
    //   followupId: '',
    //   followupDate: new Date(),
    //   followBy: '',
    //   followByName: '',
    //   followRemark: '',
    //   otherRemark: '',
    //   followupStatus: 'open',
    //   cancelReason: '',
    //   createdBy: "",
    //   updatedBy: "",
    //   sourceName: "",
    //   enquiryDate: "",
    //   EnqId: ""
    // });
    // setFollowupData([]);
    // setMode('add');
    // setCurrentFollowupId(null);
    // setIsFormDisabled(false);
    // setErrors({});
  };

  const handleCancel = async () => {
    try {
      // const flwId = currentFollowupId;
      // console.log('flwId', flwId)
      // console.log('formData.followupId', formData.followupId)
      // await fetchFollowupData(formData.followupId, "L");

      setMode('view');
      setIsFormDisabled(true);
      setErrors({});
    } catch (error) {
      toast.error('Failed to retrieve record');
      handleAdd();
    }
  };

  const handleExit = () => {
    navigate('/TableFollowUp');
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      const response = await axios.post("TrnFlwup/RetriveTrnFlwup", {
        FlwId: enqId,
        Flag: "D",
        CreatedBy: UserId
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        await fetchFollowupData(1, "N");
      } else {
        toast.error(response.data.Message || 'Delete operation failed');
      }
    } catch (error) {
      toast.error('Error occurred while deleting. Please try again.');
    }
  };

  const handleEnquiryChange = async (event, newValue) => {
    if (newValue) {
      try {
        setFormData(prevState => ({
          ...prevState,
          EnqId: newValue.Id,
          inquiryNo: newValue.Name,
        }));

        const response = await axios.post("TrnEnq/RetriveTrnEnq", {
          EnqId: parseInt(newValue.Id),
          CreatedBy: UserId,
          Flag: ""
        });

        if (response.data.Status === 0 && response.data.Data && response.data.Data.length > 0) {
          const enquiryData = response.data.Data[0];
          const followByUser = userOptions.find(
            u => u.Id.toString() === (enquiryData.FlwUserId?.toString() || '')
          );
          let status = 'open';
          if (enquiryData.Status === '0') status = 'close';
          else if (enquiryData.Status === '5') status = 'cancel';
          const visitDate = enquiryData.VisitDt ? new Date(enquiryData.VisitDt) : null;
          setFormData(prevState => ({
            ...prevState,
            propertyId: enquiryData.PropId?.toString() || '',
            propertyName: enquiryData.PropName || '',
            mobileNo: enquiryData.MobileNo || '',
            followBy: enquiryData.FlwUserId?.toString() || '',
            followByName: followByUser?.Name || '',
            followRemark: enquiryData.Remark || '',
            otherRemark: enquiryData.VisitRemark || '',
            sourceName: enquiryData.SourceName || '',
            followupDate: new Date(),
            nextFollowupDate: new Date(),
            followupStatus: status,
            enquiryDate: enquiryData.EnqDt,
            EnqId: newValue.Id,
            inquiryNo: newValue.Name,
            enquiryType: enquiryData.EnqType || '',
            enquiryDate: enquiryData.EnqDt || '',
            visitStatus: enquiryData.VisitSt === 'Y' ? 'yes' : 'no',
            visitWith: enquiryData.VisitUserId?.toString() || '',
            visitDate: visitDate,
            visitRemark: enquiryData.VisitRemark || '',
            EnqBy: enquiryData.EnqBy,
            Tenure: enquiryData.Tenure?.toString(),
          }));
          await fetchFollowupList(newValue.Id);
        } else {
          toast.error("Failed to fetch enquiry details");
        }
      } catch (error) {
        toast.error("Error fetching enquiry details. Please try again.");
      }
    } else {
      setFormData(prevState => ({
        ...prevState,
        inquiryNo: '',
        EnqId: '',
        propertyId: '',
        propertyName: '',
        mobileNo: '',
        followBy: '',
        followByName: '',
        followRemark: '',
        otherRemark: '',
        sourceName: '',
        visitWith: '',
        enquiryType: '',
        visitStatus: '',
        visitDate: null,
        visitRemark: ''
      }));
      setFollowupData([]);
    }
  };

  const handleMobileNumberChange = async (event) => {
    const mobileNo = event.target.value;
    setFormData(prevState => ({
      ...prevState,
      mobileNo
    }));

    if (mobileNo.length === 10) {
      try {
        const response = await axios.post("TrnEnq/RetriveTrnEnq", {
          MobileNo: mobileNo,
          Flag: "M",
          "EnqId": 1,
          CreatedBy: UserId
        });

        if (response.data.Status === 0 && response.data.Data && response.data.Data.length > 0) {
          const enquiryData = response.data.Data[0];
          const property = propertyOptions.find(p => p.Id === enquiryData.PropId);
          const followByUser = userOptions.find(u => u.Id === enquiryData.FlwUserId);
          let status = 'open';
          if (enquiryData.Status === '0') status = 'close';
          else if (enquiryData.Status === '5') status = 'cancel';
          const visitDate = enquiryData.VisitDt ? new Date(enquiryData.VisitDt) : null;
          setFormData(prevState => ({
            ...prevState,
            propertyId: enquiryData.PropId?.toString() || '',
            propertyName: property?.Name || enquiryData.PropName || '',
            inquiryNo: enquiryData.EnqNo || '',
            EnqId: enquiryData.EnqId?.toString() || '',
            followBy: enquiryData.FlwUserId?.toString() || '',
            followByName: followByUser?.Name || '',
            otherRemark: enquiryData.Remark || '',
            visitRemark: enquiryData.VisitRemark || '',
            sourceName: enquiryData.SourceName || '',
            followRemark: enquiryData.followRemark,
            followupDate: new Date(),
            followupStatus: status,
            nextFollowupDate: new Date(),
            enquiryType: enquiryData.EnqType || '',
            visitStatus: enquiryData.VisitSt === 'Y' ? 'yes' : 'no',
            visitWith: enquiryData.VisitUserId?.toString() || '',
            visitDate: visitDate,
            cancelReason: enquiryData.CanlRemark || ''
          }));

          if (enquiryData.EnqId) {
            await fetchFollowupList(enquiryData.EnqId.toString());
          }
        } else {
          toast.info("No enquiry found for this mobile number");
        }
      } catch (error) {
        toast.error("Error fetching enquiry details. Please try again.");
      }
    }
  };

  const handleClick = () => {
    navigate('/booking', { state: { OcupntMob: formData.OcupntMob, EnqId: formData.EnqId, mode: 'view' } });
  };

  return (
    <>
      <Box className="form-container">
        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title'
            sx={{
              display: 'flex', alignItems: 'center',
              justifyContent: 'space-between', marginTop: '20px',
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}>
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: { xs: "none", sm: "block" },
                }}
                className='three-d-button-previous'
                onClick={handlePrevious}
                disabled={mode !== 'view' || !currentFollowupId || currentFollowupId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  display: { xs: "none", sm: "block" },
                }}
                className='three-d-button-next'
                onClick={handleNext}
                disabled={mode !== 'view' || !currentFollowupId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Follow Up
            </Typography>
            <Button variant='contained' size='small'
              sx={{ mr: 1, height: 28, textTransform: 'none', bgcolor: '#635bff', ":hover": { bgcolor: '#635bff' } }}
              onClick={() => {
                if (formData.EnqId) {
                  navigate(`/enquiry?EnqId=${encodeURIComponent(formData.EnqId)}`);
                }
              }}
            >
              Enquiry</Button>
            <Box
              onClick={handleClick}
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                background: '#5c6bc0',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                color: 'white',
                padding: '2px 8px',
                borderRadius: '5px',
                lineHeight: 1.5,
                position: "relative",
                cursor: 'pointer'
              }}
            >
              <ArrowForwardIcon sx={{ mr: 0.5 }} />
              <Typography variant="body2" sx={{ color: 'white' }}>
                Book Now
              </Typography>
            </Box>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Follow-Ups"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
                hideDelete={true}
                hideEdit={true}
                disableExit={false}
                disablePrint={false}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <TextField
                  label={
                    <span>
                      Mobile No.
                      <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  value={formData.mobileNo}
                  onChange={handleMobileNumberChange}
                  name="mobileNo"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <Autocomplete
                  options={enquiryOptions}
                  getOptionLabel={(option) => option.Name || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.Id.toString() === (value?.Id?.toString() || value) ||
                    option.Name === value
                  }
                  value={
                    formData.EnqId
                      ? enquiryOptions.find(u => u.Id.toString() === formData.EnqId.toString()) || null
                      : null
                  }
                  onChange={handleEnquiryChange}
                  disabled={true}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          Enquiry No.
                          <span style={{ color: 'red' }}>*</span>
                        </span>
                      }
                      variant="filled"
                      className="custom-textfield"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="Followup ID"
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                  value={currentFollowupId || ''}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="Enq By"
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                  value={formData.EnqBy}
                  disabled={true}
                  name="EnqBy"
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                  <DateTimePicker
                    label={
                      <span>
                        Follow up Date
                        <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    value={formData.followupDate}
                    onChange={handleFollowupDateChange}
                    inputFormat="dd/MM/yyyy HH:mm"
                    // disabled={true}
                    sx={{ width: '100%' }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        variant="filled"
                        className="custom-textfield"
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12} md={3}>
                <Autocomplete
                  options={propertyOptions}
                  getOptionLabel={(option) => option.Name || ""}
                  isOptionEqualToValue={(option, value) =>
                    option.Id?.toString() === (value?.Id?.toString() || value)
                  }
                  value={
                    formData.propertyId
                      ? propertyOptions.find(p => p.Id?.toString() === formData.propertyId?.toString()) || null
                      : null
                  }
                  onChange={handlePropertyChange}
                  disabled={isFieldDisabled('propertyId')}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          Property
                          <span style={{ color: 'red' }}>*</span>
                        </span>
                      }
                      variant="filled"
                      className="custom-textfield"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  options={userOptions}
                  getOptionLabel={(option) => option.Name || ""}
                  // disabled={isFieldDisabled('followBy')}
                  disabled={true}
                  isOptionEqualToValue={(option, value) =>
                    option.Id?.toString() === (value?.Id?.toString() || value?.toString())
                  }
                  value={
                    formData.followBy && userOptions.find(u => u.Id?.toString() === formData.followBy?.toString()) || null
                  }
                  onChange={handleFollowByChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          Follow By
                          <span style={{ color: 'red' }}>*</span>
                        </span>
                      }
                      variant="filled"
                      className="custom-textfield"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <CustomAutocomplete
                  options={Relation}
                  id="RelationId-autocomplete"
                  name='RelationId'
                  label="Relation"
                  value={Relation.find(RelationId => RelationId.Id == formData.Relation) || null}
                  onChange={handleInputChange}
                  disabled={true}
                // ref={stateRef}
                // onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={1}>
                <TextField
                  id="Tenure"
                  name="Tenure"
                  label="Tenure"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Tenure}
                  onChange={handleInputChange}
                  disabled={true}
                // disabled={isFormDisabled}
                // inputRef={areaAbrvRef}
                // onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  label="Source Name"
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                  value={formData.sourceName}
                  onChange={handleInputChange}
                  name="sourceName"
                  disabled={!isFieldDisabled('sourceName')}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <FormControl fullWidth variant="filled" className="custom-textfield">
                  <InputLabel id="enquiryType-label">Enquiry Type</InputLabel>
                  <Select
                    labelId="enquiryType-label"
                    name="enquiryType"
                    value={formData.enquiryType || ''}
                    onChange={handleInputChange}
                  // disabled={isFieldDisabled("enquiryType")}
                  // disabled={true}
                  >
                    <MenuItem value="">Select Enquiry Type</MenuItem>
                    {enquiryType.map((item) => (
                      <MenuItem key={item.Id} value={item.Id}>
                        {item.Name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={2}>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel component="legend" sx={{
                    fontSize: '0.7rem',
                    color: 'rgba(0, 0, 0, 0.6)',
                    marginBottom: '-5px'
                  }}>
                    Visited
                  </FormLabel>
                  <RadioGroup
                    row
                    name="visitStatus"
                    value={formData.visitStatus || 'no'}
                    onChange={handleInputChange}
                    sx={{
                      justifyContent: 'space-around',
                      '& .MuiFormControlLabel-label': {
                        fontSize: '0.75rem'
                      }
                    }}
                  >
                    <FormControlLabel
                      value="yes"
                      control={<Radio size="small" />}
                      label="Yes"
                      // disabled={!isFieldDisabled('visitStatus')}
                      sx={{ marginRight: '4px' }}
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio size="small" />}
                      label="No"
                      // disabled={isFieldDisabled('visitStatus')}
                      sx={{ marginLeft: '4px' }}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={2}>
                <FormControl fullWidth variant="filled" className="custom-textfield" >
                  <InputLabel id="visit-with-label">Visit With</InputLabel>
                  <Select
                    labelId="visit-with-label"
                    name="visitWith"
                    value={formData.visitWith}
                    onChange={handleInputChange}
                  // disabled={
                  //   formData.visitStatus === "yes"
                  //     ? !isFieldDisabled("visitWith")
                  //     : isFieldDisabled("visitWith")
                  // }
                  >
                    {visitedwith.map((item) => (
                      <MenuItem key={item.Id} value={item.Id}>
                        {item.Name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                  <DateTimePicker
                    label="Visit Date"
                    value={formData.visitDate}
                    onChange={(newValue) => {
                      setFormData(prev => ({ ...prev, visitDate: newValue }));
                    }}
                    inputFormat="dd/MM/yyyy HH:mm"
                    // disabled={
                    //   formData.visitStatus === "yes"
                    //     ? !isFieldDisabled("visitDate")
                    //     : isFieldDisabled("visitDate")
                    // }
                    sx={{ width: '100%' }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        variant="filled"
                        className="custom-textfield"
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label="Visit Remark"
                  fullWidth
                  variant="filled"

                  className="custom-textfield"
                  value={formData.visitRemark}
                  onChange={handleInputChange}
                  name="visitRemark"
                  InputLabelProps={{
                    shrink: true,
                  }}
                // disabled={isFieldDisabled('followRemark')}
                />
              </Grid>
              {/* <Grid item xs={12} md={2}>
                <CustomAutocomplete
                  options={Relation}
                  id="RelationId-autocomplete"
                  name='RelationId'
                  label="Relation"
                  value={Relation.find(RelationId => RelationId.Id == formData.Relation) || null}
                  onChange={handleInputChange}
                  disabled={true}
                // ref={stateRef}
                // onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={1}>
                <TextField
                  id="Tenure"
                  name="Tenure"
                  label="Tenure"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Tenure}
                  onChange={handleInputChange}
                  disabled={true}
                // disabled={isFormDisabled}
                // inputRef={areaAbrvRef}
                // onKeyDown={handleKeyPress}
                />
              </Grid> */}
              <Grid item xs={12} md={3}>
                <TextField
                  id="EnqFor"
                  name="EnqFor"
                  label={
                    <span>
                      Occupant Name
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.EnqFor}
                  onChange={handleInputChange}
                  disabled={true}
                // error={error.EnqFor}
                // helperText={error.EnqFor ? '' : ''}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="OcupntMob"
                  name="OcupntMob"
                  label="Occupant MobileNo"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.OcupntMob}
                  onChange={handleInputChange}
                  disabled={true}
                //  error={error.OcupntMob}
                //  helperText={error.OcupntMob ? 'Invalid mobile number' : ''}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <CustomAutocomplete
                  id="RoomTypeId-autocomplete"
                  name='RoomTypeId'
                  label="Room Type"
                  options={RoomType}
                  value={RoomType.find(RoomTypeId => RoomTypeId.Id == formData.RoomTypeId) || null}
                  onChange={handleInputChange}
                  disabled={true}
                // ref={cityRef}
                // onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Tentitive CheckIn Date"
                  name="CheckInDt"
                  value={formData.CheckInDt}
                  onChange={handleInputChange}
                  onBlur={() => setDisplayCalendar(false)}
                  variant="filled"
                  disabled={true}
                  // disabled={isFormDisabled}
                  className="custom-textfield"
                  onClick={() => !isFormDisabled && setDisplayCalendar(!displayCalendar)}
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" >
                        <CalendarMonthIcon
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            !isFormDisabled && setDisplayCalendar(!displayCalendar);
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />

                {displayCalendar && !isFormDisabled && (
                  <div className="calendar-container"
                    style={{
                      position: 'absolute',
                      zIndex: 1000,
                      width: '280px',
                      bottom: 282,
                      fontSize: '25.4px',
                      height: '200px',
                    }}
                  >
                    <Calendar
                      onChange={handleDate}
                      value={selectedDate}
                    />
                  </div>
                )}
              </Grid>
              <Grid item xs={12} md={4.5}>
                <TextField
                  label={
                    <span>
                      Follow Remark
                      <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  fullWidth
                  variant="filled"
                  className="custom-textfield"
                  // multiline
                  // rows={1}
                  value={formData.followRemark}
                  onChange={handleInputChange}
                  name="followRemark"
                  InputLabelProps={{
                    shrink: true,
                  }}
                // disabled={!isFieldDisabled('followRemark')}
                />
              </Grid>
              <Grid item xs={12} md={3} >
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB} >
                  <DateTimePicker
                    label={
                      <span>
                        Next Follow Up date
                        <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    value={formData.nextFollowupDate}
                    onChange={handleNextFollowupDateChange}
                    // disabled={!isFieldDisabled('followupDate')}
                    inputFormat="dd/MM/yyyy HH:mm"
                    className="custom-textfield"
                    sx={{ width: '100%' }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        variant="filled"
                      // className="custom-textfield"
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={4.5}>
                <TextField
                  label="Other Remark"
                  fullWidth
                  variant="filled"
                  // multiline
                  // rows={1}
                  className="custom-textfield"
                  value={formData.otherRemark}
                  onChange={handleInputChange}
                  name="otherRemark"
                // disabled={isFieldDisabled('otherRemark')}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormLabel component="legend">Followup Status</FormLabel>
                <Box display="flex" alignItems="center" width="100%">
                  <FormControl component="fieldset" >
                    <RadioGroup
                      row
                      name="followupStatus"
                      value={formData.followupStatus}
                      onChange={handleInputChange}
                      sx={{ p: 0 }}
                    >
                      <FormControlLabel value="open" control={<Radio />} label="Open" />
                      <FormControlLabel value="close" control={<Radio />} label="Close" />
                      <FormControlLabel value="cancel" control={<Radio />} label="Cancel" />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Grid>
              {formData.followupStatus === 'open' && (
                <Grid item xs={12} md={4}>

                </Grid>
              )}
              {formData.followupStatus === 'cancel' && (
                <Grid item xs={12} md={4}>
                  <TextField
                    label={
                      <span>
                        Cancel Reason
                        <span style={{ color: 'red' }}>*</span>
                      </span>
                    }
                    fullWidth
                    variant="filled"
                    // multiline
                    // rows={1}
                    className="custom-textfield"
                    value={formData.cancelReason}
                    onChange={handleInputChange}
                    name="cancelReason"
                  />
                </Grid>
              )}
              {formData.followupStatus === 'close' && (
                <Grid item xs={12} md={4}>
                  <TextField
                    label="Booking No"
                    fullWidth
                    variant="filled"
                    // multiline
                    // rows={1}
                    className="custom-textfield"
                    value={typedBookNo}
                    error={errors.BookId}
                    helperText={errors.BookId ? '' : ''}
                    onChange={(e) => fetchBookId(e, 'E')}
                    name="BookId"
                  />
                </Grid>
              )}
              <Grid item xs={12} md={2} className="form_button">
                {mode === 'view' && (
                  <>
                    <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg,rgb(86, 92, 100), #d4d4d4)', height: '36px', }} onClick={handleAdd} disabled>
                      Submit
                    </Button>
                    <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #b9d0e9, #e9f2fa)', height: '36px', }} onClick={handleEdit}
                      disabled
                    >
                      Cancel
                    </Button>
                  </>
                )}
                {(mode === 'edit' || mode === 'add') && (
                  <>
                    <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #d4d4d4)', height: '36px', }} onClick={handleSave} >
                      {mode === 'edit' ? 'Update' : 'Submit'}
                    </Button>
                    <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #b9d0e9, #e9f2fa)', height: '36px', }} onClick={handleCancel}>
                      Cancel
                    </Button>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>

          {followupData && followupData.length > 0 ? (
            <Grid item xs={12}>
              <Paper sx={{
                width: '100%',
                overflow: 'hidden',
                border: '1px solid #e0e0e0',
                boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                borderRadius: '8px'
              }}>
                <TableContainer sx={{ maxHeight: '200px', overflowY: 'scroll' }}>
                  <Table stickyHeader aria-label="followup data table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <TableCell
                            key={column.field}
                            align={column.align || 'left'}
                            sx={{
                              minWidth: column.width,
                              fontWeight: 'bold',
                              padding: '0px 5px',
                              backgroundColor: '#f5f7fa',
                              borderBottom: '2px solid #e0e0e0',
                              fontSize: '0.875rem'
                            }}
                          >
                            {column.headerName}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {followupData.map((row, index) => (
                        <TableRow
                          key={row.id}
                          sx={{
                            '& td': {
                              padding: '0px 5px',
                              borderBottom: '1px solid #f0f0f0',
                              fontSize: '0.875rem'
                            },
                            '&:last-child td': {
                              borderBottom: 'none'
                            }
                          }}
                        >
                          {columns.map((column) => (
                            <TableCell
                              key={column.field}
                              align={column.align || 'left'}
                              sx={{
                                color: '#333',
                                '&:first-of-type': {
                                  fontWeight: 500
                                }
                              }}
                            >
                              {column.field === 'enquiryType' ? (
                                <Box
                                  component="span"
                                  sx={{
                                    backgroundColor: row.enquiryType === 'Hot' ? '#FF0000'
                                      : row.enquiryType === 'Warm' ? '#FFBF00'
                                        : row.enquiryType === 'Cold' ? '#0000FF'
                                          : row.enquiryType === 'Booked' ? '#01bc5f'
                                            : row.enquiryType === 'Refund' ? '#4d7499'
                                              : row.enquiryType === 'Not interested' ? '#FF6347'
                                                : row.enquiryType === 'Others' ? '#FFA500'
                                                  : row.enquiryType === 'Incorrect Lead' ? '#922b21'
                                                    : row.enquiryType === 'Low Budget' ? '#148f77'
                                                      : row.enquiryType === 'Not Connected' ? '#633974'
                                                        : 'inherit',
                                    color: '#fff',
                                    padding: '2px 8px',
                                    borderRadius: '4px',
                                    display: 'inline-block',
                                    fontSize: '0.75rem',
                                  }}
                                >
                                  {row[column.field]}
                                </Box>
                              ) : (
                                column.renderCell
                                  ? column.renderCell({ row })
                                  : row[column.field]
                              )}
                            </TableCell>

                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Box sx={{
                mt: 2,
                p: 2,
                textAlign: 'center',
                backgroundColor: '#f8f9fa',
                borderRadius: '8px',
                border: '1px dashed #e0e0e0'
              }}>
                <Typography variant="body2" sx={{ color: '#666' }}>
                  {formData.EnqId
                    ? "No followup data available for this inquiry"
                    : "Select an inquiry to view followup data"}
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
          columns={attributes}
          rows={followupData}
          title="Follow-Ups"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this followup record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FollowupForm;